import codes from './codes';
import questionFunctions from '../functions/question';

export const userList = 'user-list';
export const textInput = 'text-input';
export const textArea = 'text-area';
export const dateTime = 'date-time';
export const postCode = 'post-code';
export const secondaryVariantStyle = 'secondary';

export const FormGroupVariants = {
    time: 'time',
    date: 'date',
    plain: 'plain',
    buttonRadioGroup: 'buttonRadioGroup',
    radioButtonGroup: 'radioButtonGroup',
    multiSelect: 'multiSelect',
    select: 'select',
    text: 'text',
    textarea: 'textarea',
    postcodeSearchableList: 'postcodeSearchableList',
    checkbox: 'checkbox',
    currency: 'currency',
    'user-list': 'user-list',
    'text-input': 'text-input',
    'text-area': 'text-area',
    'date-time': 'date-time',
    list: 'list',
    attachment: 'attachment',
    'post-code': 'post-code',
    number: 'number',
    amount: 'amount',
    range: 'range',
    searchableList: 'searchableList',
    editor: 'editor',
    smsEditor: 'smsEditor',
    asyncSearchableList: 'asyncSearchableList',
};

export const getInputItem = (
    variant: string,
    question: {
        displayType: string;
        code: string;
        isReadonly: any;
    },
    isReadOnlyOrEditableQuestion = '',
) => {
    if (isReadOnlyOrEditableQuestion === codes.isReadOnly) {
        return FormGroupVariants.plain;
    }

    if (question?.displayType === FormGroupVariants.range) {
        return FormGroupVariants.buttonRadioGroup;
    }

    if (
        variant === FormGroupVariants.list &&
        (question?.displayType === 'horizontal-radio' ||
            question?.displayType === 'vertical-radio')
    ) {
        return FormGroupVariants.radioButtonGroup;
    }

    if (questionFunctions.isQuestionOfTypeIntegerRange(question, variant)) {
        return FormGroupVariants.select;
    }

    if (variant === FormGroupVariants.plain || question.isReadonly) {
        return FormGroupVariants.plain;
    }

    if (
        variant === FormGroupVariants[textInput] ||
        variant === FormGroupVariants.number
    ) {
        return FormGroupVariants.text;
    }

    if (variant === FormGroupVariants[textArea]) {
        return FormGroupVariants.textarea;
    }

    if (
        variant === FormGroupVariants.date ||
        variant === FormGroupVariants[dateTime]
    ) {
        return FormGroupVariants.date;
    }

    if (variant === FormGroupVariants.time) {
        return FormGroupVariants.time;
    }
    if (variant === FormGroupVariants[postCode]) {
        return FormGroupVariants.postcodeSearchableList;
    }

    if (variant === FormGroupVariants.checkbox) {
        return FormGroupVariants.checkbox;
    }

    if (variant === FormGroupVariants.list) {
        return FormGroupVariants.select;
    }

    if (variant === FormGroupVariants[userList]) {
        return FormGroupVariants.searchableList;
    }

    if (variant === FormGroupVariants.amount) {
        return FormGroupVariants.currency;
    }

    if (variant === FormGroupVariants.range) {
        return FormGroupVariants.select;
    }

    return FormGroupVariants.text;
};
